import { render, staticRenderFns } from "./PermissionsView.vue?vue&type=template&id=c857bfba&scoped=true"
import script from "./PermissionsView.vue?vue&type=script&lang=js"
export * from "./PermissionsView.vue?vue&type=script&lang=js"
import style0 from "./PermissionsView.vue?vue&type=style&index=0&id=c857bfba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c857bfba",
  null
  
)

export default component.exports